<template>
  <div>
    <div class="row">
      <div class="col-12">
        <h2 class="font-weight-bold mb-4">Timesheet Bible</h2>
        <div class="row">
          <!-- Company - Multiselect (Validated)-->
          <ValidationProvider rules="required" v-slot="{errors, classes}" name="Company" tag="div" class="form-group col-xl-12">
            <label class="form-label" for="company">Company</label>
            <multiselect v-model="company" id="company" class="requiredField" :class="classes" name="company" placeholder=""
                         :options="ms_opts.companies" label="company_name"
            ></multiselect>
            <div v-if="errors[0]" class="vvERROR">{{ errors[0] }}</div>
          </ValidationProvider>
        </div>
      </div>
      <div class="col-12">
        <hr class="mt-4 mb-1" style="border-color: #333333">
        <hr class="mt-1 mb-4" style="border-color: #333333">
      </div>
    </div>

    <div class=row v-if="company && loading_timesheet_locations">
      <div class="col-12" v-if="submitted_week_date[0].date === next_week_date[0].date">
        <h5 class="red_color">If both dates below are the same then it means a week has only been partially submitted.</h5>
        <p>Use the button to close the open week and ready the next week for submission</p>
        <button @click.prevent="close_timesheet_week" class="btn orcaBtn w-100 mb-4"
                :disabled="closing_timesheet_week" :class="closing_timesheet_week ? 'disabled' : ''">Close timesheet week
        </button>
      </div>
      
      <div class="col-4">
        <button @click.prevent="updateTimesheets" class="btn orcaBtn greenBtn mb-4"
                :disabled="generating_timesheets" :class="generating_timesheets ? 'disabled' : ''">Update timesheets
        </button>
      </div>
      <div class="col-4"></div>
      <div class="col-4">
        <button @click.prevent="generate_next_week_timesheets" class="btn orcaBtn mb-4"
                :disabled="generating_timesheets" :class="generating_timesheets ? 'disabled' : ''">Generate timesheets
        </button>
      </div>
     
      <div class="col-md-4">
        <h5>Last submitted week: <span class="font-weight-bold">{{ submitted_week_date[0].date | formatDate }}</span></h5>
      </div>
      <div class="col-md-4">
        <h5>Next timesheet week: <span class="font-weight-bold">{{ next_week_date[0].date | formatDate }}</span></h5>
      </div>
      <div class="col-md-4">
        <h5>Last available week: <span class="font-weight-bold">{{ lastAvailableWeek | formatDate }}</span></h5>
      </div>
      <div v-for="(timesheets, location, i) in next_week_timesheets" class="col-12 timesheets_tabs mt-4" role="tablist" :key="i"
           v-if="submitted_week_date[0].date !== next_week_date[0].date">
        <b-card no-body class="mb-3">
          <!-- Accordion -->
          <b-card-header header-tag="h3" role="tab" class="p-0  " style="position: relative;">
            <b-button class="btn orcaBtn clearfix" block href="#" v-b-toggle="'accordion-' + i">
                          <span class="float-left font-weight-bold text-left"
                                style="font-size: 1rem; margin-top: 10px; margin-bottom: 10px; line-height: 1;">{{
                              location
                                                                                                                }}</span>
              <span class="icon chevron float-right" style="line-height: 16px; margin-top: 10px;"></span>
            </b-button>
          </b-card-header>
          <!-- Accordion content -> Submission Table -->
          <b-collapse :id="'accordion-' + i" accordion="my-accordion" role="tabpanel">
            <b-card-body :body-class="'p-0 timesheet_card_body'">

              <div class="col-12 pt-3">
                <div class="row">
                  <div class="col-12">

                    <table class="table">
                      <thead>
                      <tr>
                        <th>Week End Date</th>
                        <th>REF ID</th>
                        <th>CCO</th>
                        <th>First Name</th>
                        <th>Surname</th>
                        <th>Job Title</th>
                        <th>Pay Type</th>
                        <th>Pay Rate</th>
                        <th>Charge Rate</th>
                        <th>Start Date</th>
                        <th>End Date</th>
                      </tr>
                      </thead>
                      <tbody>
                      <tr v-for="timesheet in timesheets">
                        <td>{{ timesheet.week_end_date }}</td>
                        <td>{{ timesheet.id }}</td>
                        <td>{{ timesheet.order_ref }}</td>
                        <td>{{ timesheet.first_name }}</td>
                        <td>{{ timesheet.surname }}</td>
                        <td>{{ timesheet.job_title }}</td>
                        <td>{{ timesheet.rate_type }}/{{ timesheet.pay_type }} {{ timesheet.pay_amount }}</td>
                        <td>&pound;{{ timesheet.pay_amount }}</td>
                        <td>&pound;{{ timesheet.charge_amount }}</td>
                        <td>{{ timesheet.start_date }}</td>
                        <td>{{ timesheet.end_date }}</td>

                      </tr>
                      </tbody>
                    </table>

                  </div>
                </div>
              </div>

            </b-card-body>
          </b-collapse>
        </b-card>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";

export default {
  name: "bible",
  components: {
    Multiselect
  },
  data() {
    return {
      loading_timesheet_locations: false,

      ms_opts: {
        companies: []
      },

      company: null,

      next_week_timesheets: null,
      submitted_week_date: null,
      next_week_date: null,
      lastAvailableWeek: null,

      closing_timesheet_week: false,
      generating_timesheets: false,
    }
  },
  beforeMount() {
    // distinct clients who have live orders
    axios.get(this.crmApiPath + 'assignments/order_job/companies').then(live_order_companies => {
      this.ms_opts.companies = live_order_companies.data
    });
  },
  methods: {
    /**
     * Splits the raw timesheet data into chunks of locations
     * with the timesheet records in each location
     * @param data
     * @returns {{}}
     */
    formatTimesheetLocationData(data) {

      let locations = {};

      for (let i in data) {
        let timesheet = data[i];

        let location = timesheet.job_address_full;

        if (typeof locations[location] === 'undefined') {
          locations[location] = [timesheet];
        }
        else {
          locations[location].push(timesheet);
        }
      }

      return locations;
    },
    /**
     * close a partially open timesheet week
     */
    close_timesheet_week() {
      this.closing_timesheet_week = true;
      axios.post(this.crmApiPath + 'timesheet/bible/company/' + this.company.id + '/close_week', {
        for_work_end_week_date: this.next_week_date[0].date
      }).then(() => {
        // reload timesheet information for company
        this.loading_timesheet_locations = false
        // get company timesheet information
        this.load_data(this.company.id);
        this.$nextTick(() => this.closing_timesheet_week = false)
      });
    },

    /**
     * generate next week's timesheet records for the company
     */
    generate_next_week_timesheets() {
      this.generating_timesheets = true;
      axios.post(this.crmApiPath + 'timesheet/bible/company/' + this.company.id + '/generate_timesheets').then(() => {
        this.load_data(this.company.id);
        this.$nextTick(() => this.generating_timesheets = false)
      })
    },

    /**
     * update timesheets
     */
     updateTimesheets() {
      this.generating_timesheets = true;
      axios.post(this.crmApiPath + 'timesheet/bible/company/' + this.company.id + '/update_timesheets').then(() => {
        this.load_data(this.company.id);
        this.$nextTick(() => this.generating_timesheets = false)
      })
    },

    /**
     * get the timesheet information for the passed company id
     * @param company_id
     */
    load_data(company_id) {
      axios.get(this.crmApiPath + 'timesheet/bible/company/' + company_id).then(timesheet_data => {
        this.next_week_timesheets = this.formatTimesheetLocationData(timesheet_data.data.next_week_timesheets)
        this.submitted_week_date = timesheet_data.data.submitted_week_date
        this.next_week_date = timesheet_data.data.next_week_date
        this.lastAvailableWeek = timesheet_data.data.last_available_week
        this.$nextTick(() => this.loading_timesheet_locations = true)
      })
    }
  },
  watch: {
    // get timesheet data for the selected company
    company(company) {
      this.loading_timesheet_locations = false
      // get company timesheet information
      this.load_data(company.id);
    }
  }
}
</script>

<style scoped>

</style>
